import { render, staticRenderFns } from "./GraficasSoc.vue?vue&type=template&id=3055e7ea&scoped=true&lang=html&"
import script from "./GraficasSoc.vue?vue&type=script&lang=js&"
export * from "./GraficasSoc.vue?vue&type=script&lang=js&"
import style0 from "./GraficasSoc.vue?vue&type=style&index=0&id=3055e7ea&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055e7ea",
  null
  
)

export default component.exports